import React from "react";
import { Box, Button, Container, Stack, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AnimatedInView from "./AnimatedInView";

interface CTABandProps {
  title?: string;
  subtitle?: string;
  whatsappMessage?: string;
}

const WHATSAPP_NUMBER = "919013573235";

/** Full-bleed terracotta gradient call-to-action band. */
const CTABand: React.FC<CTABandProps> = ({
  title = "Ready to streamline your billing?",
  subtitle = "Talk to us for the right ECR, POS or billing solution for your business — honest advice, genuine products, quick support.",
  whatsappMessage = "Hi, I'd like to know more about your billing and POS products.",
}) => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        background: theme.custom.gradients.cta,
        color: "common.white",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: "center", px: { xs: 2, sm: 3 } }}>
        <AnimatedInView variant="fadeUp">
          <Typography variant="h2" component="h2" sx={{ mb: 2 }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, opacity: 0.92, maxWidth: 560, mx: "auto" }}>
            {subtitle}
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              size="large"
              startIcon={<WhatsAppIcon />}
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                bgcolor: "#25D366",
                color: "common.white",
                px: 4,
                "&:hover": { bgcolor: "#1EBE5A" },
              }}
            >
              WhatsApp Us
            </Button>
            <Button
              variant="outlined"
              size="large"
              component={RouterLink}
              to="/contact#contact-form"
              sx={{
                px: 4,
                color: "common.white",
                borderColor: "rgba(255,255,255,0.6)",
                "&:hover": {
                  borderColor: "common.white",
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
            >
              Contact Us
            </Button>
          </Stack>
        </AnimatedInView>
      </Container>
    </Box>
  );
};

export default CTABand;
